import {Button, Checkbox, Col, Divider, Form, Input, List, Modal, Row, Select, Spin, Switch} from "antd";
import {LoadingOutlined} from "@ant-design/icons";
import ContainerComponent from "../../../helpers/components/container.component";
import PageHeaderComponent from "../../../helpers/components/page_header.component";
import globalHelper from "../../../helpers/functions/global.helper";
import React, {useState} from "react";
import {useHistory} from "react-router-dom";
import {useSelector} from "react-redux";

const RefundDetail = (props) => {

    const history = useHistory();
    const {activity} = props;
    const [state, setState] = useState({
        loading: false,
    });

    return (
        <>
            <Spin spinning={state?.loading} indicator={<LoadingOutlined/>}>
                <div style={{textAlign: 'start', marginBottom: 20,}}>
                    <div className='title-header mobile-padding-24'>
                        <ContainerComponent span={20}>
                            <PageHeaderComponent title={'Activity Details - Refund'} textAlign={'start'}/>
                        </ContainerComponent>
                    </div>
                    <div
                        className='mobile-padding-24'
                        {...!globalHelper?.isMobileScreen() && ({style: {marginTop: 24,}})}
                    >
                        <ContainerComponent span={20}>
                            <div style={{ padding: '24px' }}>
                                <h2 style={{ marginBottom: '20px' }}>Activity Details</h2>

                                <div style={{
                                    display: 'grid',
                                    gridTemplateColumns: '200px 1fr',
                                    rowGap: '12px',
                                    columnGap: '16px'
                                }}>
                                    <div><strong>Transaction No:</strong></div>
                                    <div>{activity?.transaction_no || '-'}</div>

                                    <div><strong>Transaction Type:</strong></div>
                                    <div>{activity?.transaction_type?.name || '-'}</div>

                                    <div><strong>Customer Name:</strong></div>
                                    <div>{activity?.to_wallet?.customer?.name || '-'}</div>

                                    <div><strong>Phone Number:</strong></div>
                                    <div>
                                        {activity?.to_wallet?.customer
                                            ? `${activity.to_wallet.customer.mobile_dial_no || ''}${activity.to_wallet.customer.phone_no || ''}`
                                            : '-'}
                                    </div>

                                    <div><strong>Customer Wallet ID:</strong></div>
                                    <div>{activity?.to_wallet?.name ?? '-'}</div>

                                    <div><strong>Merchant Name:</strong></div>
                                    <div>{activity?.from_wallet?.merchant?.name || '-'}</div>

                                    <div><strong>Merchant Wallet ID:</strong></div>
                                    <div>{activity?.from_wallet?.name ?? '-'}</div>

                                    <div><strong>Refund At:</strong></div>
                                    <div>{activity?.refund ? new Date(activity.refund.created_at).toLocaleString() : '-'}</div>

                                    <div><strong>Melon Amount:</strong></div>
                                    <div>{activity?.melon_amount ?? '-'}</div>

                                    <div><strong>Payment Transaction No.:</strong></div>
                                    <div>{activity?.refund?.payment?.activity?.transaction_no ?? '-'}</div>

                                    {/* Add more fields as needed */}
                                </div>
                            </div>
                        </ContainerComponent>

                    </div>
                </div>
            </Spin>
        </>
    );
};

export default RefundDetail;